import { axiosInstance } from '../App';
import { PaginatedFinancerPendingDetailsDTO } from '../dto/FinancerDistributionDTO';
import { serializeRepeatedParams } from './serializeRepeatedParams';
import { ProfessionalSettlementDTO, ProfessionalSettlementDetailItemDTO, CreateProfessionalSettlementRequestDTO, RegisterAdditionalPaymentRequestDTO, SettlementPaymentPreviewDTO } from '../dto/ProfessionalSettlementDTO';
import { ReceiptFormsDTO } from '../dto/ReceiptFormsDTO';

export interface PendingItemsQueryParams {
    billingEntityId: number;
    professionalId: number;
    /** yyyy-MM-dd HH:mm:ss */
    fromDate: string;
    toDate: string;
    /** Medio de pago de la orden. */
    paymentMethodIds?: number[];
    /** Estado de la última factura de la orden. */
    formStateTypes?: number[];
    payerTypes?: number[];
    benefitOrderStates?: number[];
    /** -1 = todas. */
    healthEntityId?: number;
    offset: number;
    pageSize: number;
}

/** Movimientos de honorario pendientes del profesional, paginados y con los totales del servidor. */
export function getPendingItems(params: PendingItemsQueryParams): Promise<PaginatedFinancerPendingDetailsDTO> {
    return axiosInstance.get('/api/secured/professionalsettlement/getPendingItems', {
        params: { healthEntityId: -1, ...params },
        paramsSerializer: serializeRepeatedParams,
    }).then(r => r.data);
}

export function createProfessionalSettlement(body: CreateProfessionalSettlementRequestDTO): Promise<ProfessionalSettlementDTO> {
    return axiosInstance.post('/api/secured/professionalsettlement/createProfessionalSettlement', body).then(r => r.data);
}

export function getClosings(offSet: number, pageSize: number, filters?: {
    professionalId?: number | null;
    billingEntityId?: number | null;
    fromDate?: string | null;
    toDate?: string | null;
}): Promise<ProfessionalSettlementDTO[]> {
    return axiosInstance.get('/api/secured/professionalsettlement/getClosings', {
        params: {
            offset: offSet,
            pageSize,
            ...(filters?.professionalId  ? { professionalId:  filters.professionalId  } : {}),
            ...(filters?.billingEntityId ? { billingEntityId: filters.billingEntityId } : {}),
            ...(filters?.fromDate        ? { fromDate:        filters.fromDate        } : {}),
            ...(filters?.toDate          ? { toDate:          filters.toDate          } : {}),
        },
    }).then(r => r.data);
}

/** Comprobante interno del cierre y todos sus pagos: la misma fuente que la ventana de la liquidación. */
export function getSettlementReceiptForms(professionalSettlementId: number): Promise<ReceiptFormsDTO> {
    return axiosInstance.get('/api/secured/professionalsettlement/getSettlementReceiptForms', {
        params: { professionalSettlementId },
    }).then(r => r.data);
}

export function getClosingDetails(professionalSettlementId: number): Promise<ProfessionalSettlementDetailItemDTO[]> {
    return axiosInstance.get('/api/secured/professionalsettlement/getClosingDetails', {
        params: { professionalSettlementId },
    }).then(r => r.data);
}

/**
 * Monto a pagar antes de cerrar: la parte del profesional más los créditos, menos los débitos y lo que debe en la
 * cuenta corriente. Los montos van como texto para no perder precisión.
 */
export function getSettlementPaymentPreview(billingEntityId: number, professionalId: number,
                                            professionalAmount: string, manualDebits = '0',
                                            manualCredits = '0'): Promise<SettlementPaymentPreviewDTO> {
    return axiosInstance.get('/api/secured/professionalsettlement/getPaymentPreview', {
        params: { billingEntityId, professionalId, professionalAmount, manualDebits, manualCredits },
    }).then(r => r.data);
}

export function registerAdditionalPayment(body: RegisterAdditionalPaymentRequestDTO): Promise<void> {
    return axiosInstance.post('/api/secured/professionalsettlement/registerAdditionalPayment', body).then(r => r.data);
}
